@import 'abstract/colors';
@import 'abstract/variables';
@import 'buttons';

.cant-order-overlay-block {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: none;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background: $popup-background;
  z-index: 1000;

  &.active {
    display: flex;
    animation: modal-background .3s;
  }

  > * {
    margin: 1em;
  }
  .modal {
    max-width: calc(100% - 30px) !important;
    @media screen and (max-height: $mobile-screen-height) {
      max-height: none;
    }
    &-container {
      border: solid $white;
      border-width: 60px 42px !important;
      border-radius: 12px;
      overflow: hidden;
      width: 750px;
      max-width: 100%;
      box-sizing: border-box;
      background: $white;
      &--sm {
        border-width: 30px 20px !important;
      }
      @include breakpoint(sm) {
        border-width: 30px 20px !important;
      }
      @media screen and (max-height: $mobile-screen-height) {
        border-width: 30px 20px !important;
      }
    }
    &-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      background: $white;
    }
  }
}
.image {
  img {
    max-width: 100%;
    @media screen and (max-height: $mobile-screen-height) {
      max-height: 30vh;
      display: block;
    }
  }
}
.title {
  margin: 0 0 20px;
  max-width: 100%;
  font-size: 27px;
  font-weight: 600;
  text-align: center;
  @include breakpoint(sm) {
    font-size: 21px;
  }
  @media screen and (max-height: $mobile-screen-height) {
    font-size: 18px;
    margin: 0 0 10px;
  }
  b {
    color: $blue;
  }
}
.subtitle {
  margin: 0 0 40px;
  max-width: 100%;
  font-size: 21px;
  text-align: center;
  @include breakpoint(sm) {
    font-size: 18px;
  }
  @media screen and (max-height: $mobile-screen-height) {
    font-size: 16px;
    margin: 0 0 20px;
  }
  span {
    color: $blue;
  }
}
.text {
  margin: 0 0 20px;
  font-size: 21px;
  text-align: center;
  @include breakpoint(sm) {
    font-size: 16px;
  }
  @media screen and (max-height: $mobile-screen-height) {
    font-size: 16px;
    margin: 0 0 10px;
  }
}
.action {
  &-list {
    display: flex;
    align-items: center;
    width: 100%;
    margin: 0 -10px;
    list-style-type: none;
    @include breakpoint(sm) {
      flex-direction: column;
      margin: 0;
    }
  }
  &-item {
    flex-grow: 1;
    width: 50%;
    padding: 0 10px;
    @include breakpoint(sm) {
      padding: 0;
      margin: 0 0 10px;
      width: 100%;
    }
  }
  &-button {
    font-size: 16px !important;
    height: auto !important;
    letter-spacing: 0 !important;
    padding: 20px 14px !important;
    max-width: none !important;
    line-height: 1.4;
    color: $white;
    width: 100%;
    @media screen and (max-height: $mobile-screen-height) {
      padding: 15px 14px !important;
    }
  }
}
